import React__default from 'react';
import Box from '../Box/Box.js';
import { ContentStack, CardMediaRoot, Img } from './styles.js';

// import {Box, CardProps} from '../..'

// --------------------------------------------------------
// Card base
const Root = ({
  children,
  as = 'div',
  sx: sxProp
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    as: as,
    sx: sxProp
  }, children);
};
Root.displayName = "Root";
Root.displayName = 'Card';

// --------------------------------------------------------
// Content
const Content = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React__default.createElement(ContentStack, {
    sx: sxProp
  }, children);
};
Content.displayName = "Content";
Content.displayName = 'Card.Content';

// --------------------------------------------------------
// Header
const Header = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    as: "div",
    sx: sxProp
  }, children);
};
Header.displayName = "Header";
Header.displayName = 'Card.Header';

// --------------------------------------------------------
// Body
const Body = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    as: "div",
    sx: sxProp
  }, children);
};
Body.displayName = "Body";
Body.displayName = 'Card.Body';

// --------------------------------------------------------
// Media
// TODO: refs
const Media = ({
  children,
  sx: sxProp,
  src,
  alt
}) => {
  return /*#__PURE__*/React__default.createElement(CardMediaRoot, {
    sx: sxProp
  }, /*#__PURE__*/React__default.createElement(Img, {
    src: src,
    alt: alt
  }), children);
};
Media.displayName = "Media";
Media.displayName = 'Card.Media';

// --------------------------------------------------------
// Actions
const Actions = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: sxProp
  }, children);
};
Actions.displayName = "Actions";
Actions.displayName = 'Card.Actions';

// --------------------------------------------------------
// Footer
const Footer = ({
  children,
  sx: sxProp
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: sxProp,
    as: "div"
  }, children);
};
Footer.displayName = "Footer";
Footer.displayName = 'Card.Footer';

// --------------------------------------------------------
// Export
const Card = Object.assign(Root, {
  Content,
  Media,
  Header,
  Body,
  Actions,
  Footer
});

export { Card };
